<div [class]="classes()" [style.margin-left.px]="level() * indent()">
  @if (isContainer()) {
    <button
      type="button"
      class="esn-tree-row__chevron"
      [class.esn-tree-row__chevron--open]="expanded()"
      [attr.aria-label]="expanded() ? 'Collapse' : 'Expand'"
      [attr.aria-expanded]="expanded()"
      [attr.tabindex]="chevronTabbable() ? null : -1"
      (click)="toggle($event)"
    >
      <esn-icon name="chevron-right" [size]="12" />
    </button>
  } @else if (isSlot()) {
    <span [class]="'esn-tree-row__dot esn-tree-row__dot--' + kind()"></span>
  } @else if (contentType(); as type) {
    <esn-content-type-icon [type]="type" [external]="external()" />
  } @else {
    <span class="esn-tree-row__glyph"><esn-icon [name]="contentIcon()" [size]="20" /></span>
  }

  @if (kind() === 'world') {
    <esn-icon class="esn-tree-row__lock" name="lock" [size]="12" />
  }

  <span class="esn-tree-row__label"><ng-content /></span>

  @if (meta(); as m) {
    <span class="esn-tree-row__meta">{{ m }}</span>
  }
  @if (chip(); as c) {
    <span class="esn-tree-row__chip">{{ c }}</span>
  }
</div>
